import { render, staticRenderFns } from "./PackageAddModal.vue?vue&type=template&id=6cca21cd"
import script from "./PackageAddModal.vue?vue&type=script&lang=js"
export * from "./PackageAddModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports